import React, { useState } from "react";
import { Form, Button, Alert } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import "./style.scss";
import { gql, useMutation } from "@apollo/client";

const CHANGE_PASS_MUTATION = gql`
  mutation changePassword($token: String, $hash: String) {
    changePassword(obj: { token: $token, hash: $hash }) {
      status
    }
  }
`;

function New() {
  const { id } = useParams();
  const history = useNavigate();
  const [querys, { loading }] = useMutation(CHANGE_PASS_MUTATION);
  const [isValid, setIsValid] = useState("");
  const [variant, setVariant] = useState("danger");
  const [inputForm, setForm] = useState({
    password1: "",
    password2: "",
  });

  let formChange = (event) => {
    const values = { ...inputForm };
    values[event.target.name] = event.target.value;
    setForm(values);
  };

  const submitForm = (event) => {
    if (event) event.preventDefault();

    const values = { ...inputForm };

    if (!id) {
      setVariant("danger");
      return setIsValid("Invalid or missing reset link.");
    }

    if (!values.password1 || !values.password2) {
      setVariant("danger");
      return setIsValid("Please enter and confirm your new password.");
    }

    if (values.password1 !== values.password2) {
      setVariant("danger");
      return setIsValid("Passwords do not match.");
    }

    if (
      !values.password1.match(
        /^.*(?=.{8,})(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%&]).*$/
      )
    ) {
      setVariant("danger");
      return setIsValid(
        'Please enter a strong password (8+ chars), e.g. "Abcd123&"'
      );
    }

    querys({ variables: { hash: values.password1, token: id } })
      .then((res) => {
        if (res.data?.changePassword?.status) {
          setVariant("success");
          setIsValid("Password changed successfully. You can login now.");
          setTimeout(() => history("/login"), 1500);
        } else {
          setVariant("danger");
          setIsValid("Unable to change password. Link may be invalid or expired.");
        }
      })
      .catch(() => {
        setVariant("danger");
        setIsValid("Unable to change password. Please try again.");
      });
  };

  return (
    <div id="forget">
      {isValid ? <Alert variant={variant}>{isValid}</Alert> : ""}
      <div className="d-flex align-items-center auth px-0 mt-5">
        <div className="row w-100 mx-0">
          <div className="col-lg-4 mx-auto">
            <span>
              Password *(Must be more than 8 digit -15 ) eg-"Abcd123&"
            </span>
            <form onSubmit={submitForm}>
              <Form.Group className="mb-3" controlId="formNewPassword">
                <Form.Label>New Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Enter New Password"
                  name="password1"
                  value={inputForm.password1}
                  onChange={(e) => formChange(e)}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formConfirmPassword">
                <Form.Label>Confirm Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Enter New Password"
                  name="password2"
                  value={inputForm.password2}
                  onChange={(e) => formChange(e)}
                />
              </Form.Group>
              <div className="ctdc-btn">
                <Button
                  className="submit-btn"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Submitting..." : "Submit"}
                </Button>
              </div>
            </form>

            <Link to="/login">Login</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default New;
